import styled, { keyframes, css } from "styled-components";

const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.02);
  }
  100% {
    transform: scale(1);
  }
`;

export const HeaderContainer = styled.div`
    display: flex;
    margin: 40px auto;
    margin-top: 10px;
    max-width: 900px;
    align-items: center;
    
    @media (max-width: 1000px) { 
        padding: 0 70px;
        margin-bottom: 0;
    }

    @media (max-width: 815px) { 
        
        padding: 0 70px;
        margin-bottom: 0;
    }
    
    @media (max-width: 700px) { 
        
        padding: 0 70px;
        padding-top: 25px;
        margin-bottom: 0;
    }
    
    @media (max-width: 400px) { 
        padding: 25px;
        margin-bottom: 0;
    }
`;

export const HeaderTitle = styled.h1`
  color: #e0e0e0;
  font-size: 26px;
  
  @media (max-width: 815px) {
    display: inline;
  }
  @media (max-width: 400px) {
    font-size: 17px;
  }
`;

export const HeaderNumber = styled.h1`
  font-size: 22px;
  font-weight: normal;
  margin-right: 10px;
  color: #BB86FC;

  @media (max-width: 815px) {
    display: inline;
  }
  @media (max-width: 400px) {
    font-size: 15px;
  }
`;

export const Container = styled.div`
  max-width: 900px;
  margin: 40px auto;
  font-size: 17px;
  
  @media (max-width: 1000px) { 
      padding: 0 70px;
  }
  
  @media (max-width: 815px) { 
      display: block;
      margin-top: 20px;
  }
  
  @media (max-width: 700px) { 
      display: block;
      margin-top: 20px;
  }
  
  @media (max-width: 400px) {
      margin-top: 0px; 
      padding: 0px 25px;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 5px;
  margin-top: 40px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

export const CategoryCard = styled.div`
  background: rgba(187, 134, 252, 0.03);
  border-radius: 8px;
  padding: 10px;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    background: rgba(187, 134, 252, 0.05);
    
    ${props => props['data-aos-delay'] && css`
      animation: ${pulseAnimation} 1s ease-in-out;
    `}
  }
`;

export const CategoryTitle = styled.h3`
  color: #BB86FC;
  font-size: 18px;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(187, 134, 252, 0.2);
`;

export const SkillsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const SkillItem = styled.li`
  position: relative;
  padding-left: 20px;
  margin-bottom: 12px;
  color: #969696;
  font-size: 14px;
  line-height: 1.6;
  transition: all 0.2s ease;
  
  &:before {
    content: '▹';
    position: absolute;
    left: 0;
    color: #BB86FC;
    opacity: 0.8;
  }
  
  &:hover {
    color: #e0e0e0;
    transform: translateX(5px);
    
    &:before {
      opacity: 1;
    }
  }
`; 